"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pill = exports.NeutralPill = exports.ActivePill = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _pillModule = _interopRequireDefault(require("./pill.module.scss"));
var Pill = function Pill(_ref) {
  var children = _ref.children,
    variant = _ref.variant,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_pillModule.default['pill'], _pillModule.default["pill--".concat(variant)], className)
  }, children);
};
exports.Pill = Pill;
var NeutralPill = function NeutralPill(props) {
  return /*#__PURE__*/_react.default.createElement(Pill, Object.assign({}, props, {
    variant: "neutral"
  }));
};
exports.NeutralPill = NeutralPill;
var ActivePill = function ActivePill(props) {
  return /*#__PURE__*/_react.default.createElement(Pill, Object.assign({}, props, {
    variant: "active"
  }));
};
exports.ActivePill = ActivePill;